export default {
      id: "search-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#search",
      toString: function () {
        return this.url;
      }
    }